<script setup lang="ts">
import type { ButtonProps } from '#ui/types';
import lodashOmit from 'lodash-es/omit';

export interface StoryblokUiButtonProps {
    blok: StoryblokUiButton;
}

// PROPS
const { blok } = defineProps<StoryblokUiButtonProps>();

// DATA
const to = computed(() => (blok.to ? storyblokResolveLink(blok.to) : undefined));
const buttonProps = computed<ButtonProps>(() => lodashOmit(storyblokOmitEmptyValues<StoryblokUiButton>(blok), ['_uid', 'component', 'to', 'center']));
</script>

<template>
    <span v-editable="blok" class="contents">
        <UButton v-bind="buttonProps" :to="to" />
    </span>
</template>
